import React from 'react';

export const SuperiroCategoriasEmpresa = (props) => {
	const {cambioNotificaciones, TipoNotificaciones} = props;
	return (
		<div className='HeadPresupuesto'>
			<div className='superiorHeadContentPresupuestos'>
				<div className='centrador derSuperiorHeadContentPresupuestos'>
					<div>
						<svg
							xmlns='http://www.w3.org/2000/svg'
							width='40'
							height='40'
							fill='currentColor'
							className='bi bi-grid'
							viewBox='0 0 16 16'
						>
							<path d='M1 2.5A1.5 1.5 0 0 1 2.5 1h3A1.5 1.5 0 0 1 7 2.5v3A1.5 1.5 0 0 1 5.5 7h-3A1.5 1.5 0 0 1 1 5.5v-3zM2.5 2a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 1h3A1.5 1.5 0 0 1 15 2.5v3A1.5 1.5 0 0 1 13.5 7h-3A1.5 1.5 0 0 1 9 5.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zM1 10.5A1.5 1.5 0 0 1 2.5 9h3A1.5 1.5 0 0 1 7 10.5v3A1.5 1.5 0 0 1 5.5 15h-3A1.5 1.5 0 0 1 1 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3zm6.5.5A1.5 1.5 0 0 1 10.5 9h3a1.5 1.5 0 0 1 1.5 1.5v3a1.5 1.5 0 0 1-1.5 1.5h-3A1.5 1.5 0 0 1 9 13.5v-3zm1.5-.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3z' />
						</svg>
					</div>
					<div className='centrador titleHeadHistorialFacturas'>
						<b>Categorias y servicios.</b>
					</div>
				</div>
			</div>
			<div className='separador'></div>

			<div className='menuPresupuestos BotonesSuperiorPresupuestos'>
				<div
					className={TipoNotificaciones[0]}
					onClick={() => {
						cambioNotificaciones(0);
					}}
				>
					<div className='centrador'>Activos</div>
				</div>

				<div
					className={TipoNotificaciones[1]}
					onClick={() => {
						cambioNotificaciones(1);
					}}
				>
					<div className='centrador'>Inactivos</div>
				</div>

				<div
					className={TipoNotificaciones[2]}
					onClick={() => {
						cambioNotificaciones(2);
					}}
				>
					<div className='centrador'>Pendientes</div>
				</div>

				<div
					className={TipoNotificaciones[3]}
					onClick={() => {
						cambioNotificaciones(3);
					}}
				>
					<div className='centrador'>Añadir</div>
				</div>
			</div>
		</div>
	);
};
